export default [
  {
    path: "/tools",
    name: "tools",
    component: () => import("@/views/tools/ToolsView.vue"),
  },
  {
    path: "/polaroid",
    name: "polaroid",
    component: () => import("@/views/polaroid/PolaroidView.vue"),
  },
];
